import fileSys from "../../fileoprators/fileSystem";
import { FILES, isDefined } from "../shared";
import RgpApi from "./RGPAPI";
import { INVALID_1000 } from "../../shared/consts";
const DATA_W = 601;
const DATA_H = 601;

function isPtrValid() {
  let arr = [...arguments];
  if (arr.length <= 0) return false;

  return arr.every((val) => {
    return typeof val === "number" && !isNaN(val) && val > 0;
  });
}

export default class RGP {
  constructor(casepath) {
    this.ptrCorneaLensData = this.ptrCornea = this.ptrLens = this.ptrLensz = this.ptrRender = 0;
    this.casepath = casepath;
    this.updateLensOnly = false;

    this.transmatrix = new Float32Array(16);
    this.depth1 = new Float64Array(DATA_W * DATA_H);
    this.depth2 = new Float64Array(DATA_W * DATA_H);
  }
  fInitPtrs() {
    let cartPath = fileSys.combinePath(this.casepath, FILES.cartCrnf);
    let acPath = fileSys.combinePath(this.casepath, FILES.acdotana);
    let obj = RgpApi.initfCorneaLensData(cartPath, acPath);
    if (isDefined(obj)) {
      this.ptrCorneaLensData = obj.ptr;
      this.ptrCornea = obj.ptrCornea;
      this.ptrLens = obj.ptrLens;
      this.ptrLensz = obj.ptrLensz;
    }
    this.ptrRender = RgpApi.renderer3DInit(
      400,
      400,
      DATA_W,
      DATA_H,
      fileSys.getStaticImagePath("pos.png")
    ).ptr;
    return isPtrValid(
      this.ptrCorneaLensData,
      this.ptrCornea,
      this.ptrLens,
      this.ptrLensz,
      this.ptrRender
    );
  }
  fCalcSFeccK(dia) {
    let arrNum = 4;
    let flatBuffer = new Float64Array(arrNum);
    let steepBuffer = new Float64Array(arrNum);
    let cartPath = fileSys.combinePath(this.casepath, FILES.cartSagf);
    let result = RgpApi.calcSFecckOneDia(cartPath, dia, flatBuffer.buffer, steepBuffer.buffer);
    return { result, flatBuffer, steepBuffer };
  }
  fCalcRiseArch(dia) {
    let result = false;
    if (!isPtrValid(this.ptrCorneaLensData)) {
      return { result };
    }
    let out360 = new Float64Array(360);
    result = RgpApi.calcRiseArch(this.ptrCorneaLensData, dia, out360.buffer);
    return { result, out360 };
  }
  fProduceLens(radius, width, ecc, arcNum) {
    let result = false;
    if (
      !isPtrValid(this.ptrCorneaLensData) ||
      !Array.isArray(radius) ||
      !Array.isArray(width) ||
      !Array.isArray(ecc) ||
      radius.length < arcNum ||
      width.length < arcNum ||
      ecc.length < arcNum
    ) {
      return result;
    }
    let bufR = new Float64Array(radius);
    let bufW = new Float64Array(width);
    let bufE = new Float64Array(ecc);
    result = RgpApi.lensSurfaceProduce(
      this.ptrCorneaLensData,
      bufR.buffer,
      bufW.buffer,
      bufE.buffer,
      arcNum
    );
    return result;
  }
  fGenTransMatrix(offsetX, offsetY, offsetZ) {
    let result = false;

    if (!isPtrValid(this.ptrCorneaLensData)) {
      return result;
    }
    result = RgpApi.genTransMatrix(
      this.ptrCorneaLensData,
      this.transmatrix.buffer,
      offsetX,
      offsetY,
      offsetZ
    );
    return result;
  }
  fGetMapData(needUpdateLens) {
    if (!isPtrValid(this.ptrRender, this.ptrCornea, this.ptrLens)) {
      return false;
    }

    let result = true;
    if (!this.updateLensOnly) {
      result = RgpApi.renderer3DUpdateVertices(this.ptrRender, this.ptrCornea, this.ptrLens);
    } else if (needUpdateLens) {
      result = RgpApi.renderer3DUpdateVertices(this.ptrRender, 0, this.ptrLens);
    }
    if (!result) {
      return result;
    }
    result = RgpApi.renderer3DUpdateTransform(this.ptrRender, this.transmatrix.buffer);
    if (!result) {
      return result;
    }
    result = RgpApi.renderer3DDraw(
      this.ptrRender,
      this.depth1.buffer,
      this.depth2.buffer,
      this.depth1.length
    );
    if (!result) {
      return result;
    }
    this.updateLensOnly = true;
    // for (let i = 0; i < this.depth2.length; i++) {
    //   this.depth1[i] = Math.random() / 10
    //   this.depth2[i] = Math.random() / 10
    // }
    for (let i = 0; i < this.depth2.length; i++) {
      if (this.depth2[i] === INVALID_1000) continue;
      this.depth2[i] *= 1000;
    }
    const LEN = 360;
    let dataX = new Float64Array(LEN);
    let dataY = new Float64Array(LEN);
    result = RgpApi.lensEdgein2Dimension(
      this.ptrCorneaLensData,
      this.transmatrix.buffer,
      dataX.buffer,
      dataY.buffer,
      LEN
    );
    let edgeInfo = [];
    let x, y;
    for (let i = 0; i < dataY.length; i++) {
      x = y = 0;
      if (Math.abs(dataX[i]) >= 0.0001 && Math.abs(dataX[i]) <= 12) {
        x = dataX[i];
      }
      if (Math.abs(dataY[i]) >= 0.0001 && Math.abs(dataY[i]) <= 12) {
        y = dataY[i];
      }
      edgeInfo.push({ x, y });
    }

    return { result, mapData: this.depth2, edgeInfo };
  }
  fGetTearThickData(rotateAngle, width, arcNum) {
    let result = false;

    if (!isPtrValid(this.ptrRender, this.ptrCornea, this.ptrLens)) {
      return result;
    }
    let lenDia = 0;
    let sum = 0;
    for (let i = 0; i < arcNum; i++) {
      sum += width[i];
    }
    lenDia = 2.0 * sum;
    let num = parseInt(lenDia / 0.02) + 1;
    let thickoutOneSection = new Float64Array(num);
    if (rotateAngle < 0) {
      rotateAngle += 360;
    }
    result = RgpApi.intersectionTearthick(
      this.depth1.buffer,
      rotateAngle,
      lenDia / 2,
      thickoutOneSection.buffer
    );
    // thickoutOneSection[0] = 0.4
    // for (let i = 0; i < thickoutOneSection.length; i++) {
    //   if (i > 500) {
    //     thickoutOneSection[i] = thickoutOneSection[i - 1] + 0.001
    //   } else if (i > 0) {
    //     thickoutOneSection[i] = thickoutOneSection[i - 1] - 0.001
    //   }
    //   if (thickoutOneSection[i] < 0.05) {
    //     thickoutOneSection[i] = 0.05
    //   } else if (thickoutOneSection[i] > 0.45) {
    //     thickoutOneSection[i] = 0.45
    //   }
    // }
    // console.log(thickoutOneSection)
    if (result) {
      let revert = Math.abs(rotateAngle) < 90 || Math.abs(rotateAngle) > 270;
      if (num > 2) {
        if (thickoutOneSection[0] < 0.01) {
          thickoutOneSection[0] = thickoutOneSection[1];
        }
        if (thickoutOneSection[num - 1] < 0.01) {
          thickoutOneSection[num - 1] = thickoutOneSection[num - 2];
        }
      }
      if (revert) {
        thickoutOneSection.reverse();
      }

      let dataX = new Array(thickoutOneSection.length);
      let dataY = new Array(thickoutOneSection.length);
      dataY.fill(INVALID_1000);
      for (let i = 0; i < thickoutOneSection.length; i++) {
        dataX[i] = i * 0.01;
        if (Math.abs(thickoutOneSection[i] + 1000) < 0.001) {
          if (i >= 1) {
            dataY[i] = dataY[i - 1];
          }
        } else {
          if (thickoutOneSection[i] < 0) {
            dataY[i] = 0;
          } else {
            dataY[i] = thickoutOneSection[i] * 1000;
          }
        }
      }
      return { result, data: { x: dataX, y: dataY } };
    }
  }
  freePtrs() {
    if (isPtrValid(this.ptrCorneaLensData)) {
      RgpApi.freeCorneaLensData(this.ptrCorneaLensData);
    }
    if (isPtrValid(this.ptrRender)) {
      RgpApi.renderer3DRelease(this.ptrRender);
    }
  }
}



// WEBPACK FOOTER //
// ./src/topography/js/RGP.js